"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  CONTEXT_KEY: true,
  DATA_CACHE_TIMEOUT: true,
  SCHEDULED_CLEANUP_KEY: true,
  USER_COOKIE_NAME: true,
  POST_INIT_EVENT_DELAY: true,
  LOG_COLOR: true,
  REFERER: true
};
exports.USER_COOKIE_NAME = exports.SCHEDULED_CLEANUP_KEY = exports.REFERER = exports.POST_INIT_EVENT_DELAY = exports.LOG_COLOR = exports.DATA_CACHE_TIMEOUT = exports.CONTEXT_KEY = void 0;
var _constantsGenerated = require("../constants-generated");
Object.keys(_constantsGenerated).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _constantsGenerated[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _constantsGenerated[key];
    }
  });
});
/** Storage key under which the shopping context data gets stored. */
const CONTEXT_KEY = exports.CONTEXT_KEY = 'shoppingContext';

/** Local storage data will be cleaned on next reload when older than this timeout (currently 5 minutes in ms). */
const DATA_CACHE_TIMEOUT = exports.DATA_CACHE_TIMEOUT = 300000;

/** In some situations, we mark the local cache to be cleaned after page reload with this flag. */
const SCHEDULED_CLEANUP_KEY = exports.SCHEDULED_CLEANUP_KEY = `basket-provider cache cleanup`;

/** User cookie helps identifying the current shopping session. */
const USER_COOKIE_NAME = exports.USER_COOKIE_NAME = 'ShoppingKey';

/**
 * Experimental delay before the shopping-context-loaded event gets triggered.
 * This is here to fix problems in automated UI tests, if possible.
 */
const POST_INIT_EVENT_DELAY = exports.POST_INIT_EVENT_DELAY = 200;
const LOG_COLOR = exports.LOG_COLOR = '090';

/* Additional headers for the API requests. TODO: Move to checkout-utils or similar. */
const REFERER = exports.REFERER = 'x-referer';